const tableCellManagementService = {
  photo: 'FOTO'
};

export default tableCellManagementService;
